import { css, Theme } from "@emotion/react"

export const chooseShippingMethodOptionStyle = css`
	color: #111827;
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 12px;
`

export const estimatedDeliveryStyle = css`
	color: #111827;
	font-size: 16px;
	font-weight: 700;
	margin-bottom: 16px;
`

export const quantityContainer = (theme: Theme) => css`
	${theme.breakpoints.down("xs")} {
		margin-left: 6.4rem;
		margin-top: 1.125rem;
	}

	div.quantitySelect,
	> div {
		width: 100%;
	}
`
export const itemListStyle = (theme: Theme) => css`
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #e5e6e6;
	padding: 1.5rem 0;

	:nth-last-of-type(1) {
		border-bottom: none;
		padding-bottom: 0;
	}

	${theme.breakpoints.down("xs")} {
		display: block;
	}
`

export const itemStyle = css`
	display: flex;
`

export const underlineHoverStyle = css`
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
`

export const partNumberStyle = css`
	color: #4b5563;
	font-size: 0.875rem;
	font-weight: 400;
`

export const accesorialsContainerStyle = css`
	margin: 1.125rem 0;
`

export const willCallAddressTextStyle = css`
	font-size: 0.8rem;
	margin-left: 2rem;
`

export const shipmentTypeIconStyle = (theme: Theme) => css`
	display: inline-block;
	width: 0.25rem;
	height: 1.5rem;
	margin-right: 0.5rem;
	border-radius: 2px;
	background: ${theme.palette.colors.brandDeepNavy};
`

export const shipmentTypeHeaderStyle = css`
	text-transform: capitalize;
	margin: 0 0 0.5rem;
	display: flex;
	align-items: center;
	font-weight: 700;
	flex-direction: row;
`
